/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ACTIVE: the letter of intent stands. LAPSED: the contract deadline passed.
 * TRANSACTION_CREATED: ops created the transaction from it.
 * @export
 */
export const HomeownershipLockStatus = {
    Active: 'active',
    Lapsed: 'lapsed',
    TransactionCreated: 'transaction_created'
} as const;
export type HomeownershipLockStatus = typeof HomeownershipLockStatus[keyof typeof HomeownershipLockStatus];


export function HomeownershipLockStatusFromJSON(json: any): HomeownershipLockStatus {
    return HomeownershipLockStatusFromJSONTyped(json, false);
}

export function HomeownershipLockStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipLockStatus {
    return json as HomeownershipLockStatus;
}

export function HomeownershipLockStatusToJSON(value?: HomeownershipLockStatus | null): any {
    return value as any;
}

